import { Assets } from './assets';
import { MockAssets } from './mock-assets';

const AssetsLoader = (isMock, include = true) => {
    if (!include) return {};

    return isMock ? MockAssets : Assets;
};

export { AssetsLoader };
